import { useEffect, useRef, useState } from "react"

// Click-outside + Escape-to-close behavior shared by dropdown-style popovers
// (see components/Select.tsx, which predates this extraction and still has
// the logic inlined).
export function usePopover<T extends HTMLElement>() {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<T>(null)

  useEffect(() => {
    if (!open) return
    function onPointerDown(e: MouseEvent) {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false)
      }
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") setOpen(false)
    }
    document.addEventListener("mousedown", onPointerDown)
    document.addEventListener("keydown", onKeyDown)
    return () => {
      document.removeEventListener("mousedown", onPointerDown)
      document.removeEventListener("keydown", onKeyDown)
    }
  }, [open])

  return { open, setOpen, rootRef }
}
